module.exports = __webpack_public_path__ + "img/115.d2f76abc.jpg";